export const fundArray = [
  {
    title: 'Save the Children',
    url: 'https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis',
    img: require('../../images/png/support-ukraine/save-the-children.png'),
    img2: require('../../images/png/support-ukraine/save-the-children@2x.png'),
  },
  {
    title: 'Project HOPE',
    url: 'https://www.projecthope.org/country/ukraine/',
    img: require('../../images/png/support-ukraine/project-hope.png'),
    img2: require('../../images/png/support-ukraine/project-hope@2x.png'),
  },
  {
    title: 'UNITED24',
    url: 'https://u24.gov.ua/uk',
    img: require('../../images/png/support-ukraine/united24.png'),
    img2: require('../../images/png/support-ukraine/united24@2x.png'),
  },
  {
    title: 'International Medical Corps',
    url: 'https://internationalmedicalcorps.org/country/ukraine/',
    img: require('../../images/png/support-ukraine/international-medical-corps.png'),
    img2: require('../../images/png/support-ukraine/international-medical-corps@2x.png'),
  },
  {
    title: 'Medicins Sans Frontieres',
    url: 'https://www.msf.org/ukraine',
    img: require('../../images/png/support-ukraine/medecins-sans-frontieres.png'),
    img2: require('../../images/png/support-ukraine/medecins-sans-frontieres@2x.png'),
  },
  {
    title: 'RAZOM',
    url: 'https://www.razomforukraine.org/',
    img: require('../../images/png/support-ukraine/razom.png'),
    img2: require('../../images/png/support-ukraine/razom@2x.png'),
  },
  {
    title: 'Action against hunger',
    url: 'https://www.actionagainsthunger.org/location/europe/ukraine/',
    img: require('../../images/png/support-ukraine/action-against-hunger.png'),
    img2: require('../../images/png/support-ukraine/action-against-hunger@2x.png'),
  },
  {
    title: 'World vision',
    url: 'https://www.wvi.org/emergencies/ukraine',
    img: require('../../images/png/support-ukraine/world-vision.png'),
    img2: require('../../images/png/support-ukraine/world-vision@2x.png'),
  },
  {
    title: 'Serhiy Prytula Charity Foundation',
    url: 'https://prytulafoundation.org/en',
    img: require('../../images/png/support-ukraine/charity-foundation.png'),
    img2: require('../../images/png/support-ukraine/charity-foundation@2x.png'),
  },
];
